import {
  style,
  animate,
  transition,
  state,
  AnimationStateMetadata,
  AnimationTransitionMetadata,
} from '@angular/animations';

export const offLabelAnimations = [
  state(
    'in',
    style({ opacity: 1, right: '50%', transform: 'translateX(50%)' })
  ),
  state('out', style({ opacity: 0 })),
  transition('* => *', animate(150)),
];

export const onLabelAnimations = [
  state(
    'in',
    style({ opacity: 1, left: '50%', transform: 'translateX(-50%)' })
  ),
  state('out', style({ opacity: 0 })),
  transition('* => *', animate(150)),
];
